import React, { useEffect, useState } from 'react';
import Sidebar from "./Sidebar";
import DashboardHeader from "./DashboardHeader";
import APIs from '../../APIs';

const Notifications = () => {
  const [loading, setLoading] = useState(true);
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const [notificationList, setNotificationList] = useState([])
  useEffect(() => {
    notificationList2()
  }, [])

  const notificationList2 = async () => {
    setLoading(true);
    try {
      const res = await APIs.post("serviceProvider/getNotificationByUserId", {
        sp_id: userData.user_id,
        user_type: 'Customer'
      });

      const data = res?.data?.data;
      console.log("res", data)
      if (data) {
        setLoading(false);
        setNotificationList(res.data.data)
      } else {
        setLoading(false);

      }
    } catch (err) {
      console.error("Error fetching fetchChatList", err);
      setLoading(false);

    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {/* Page Content */}
      <div className="page-content">
        {/* About-us start */}
        <section className="step-section-md">
          <div className="container">
            <div className="row">
              {/* Sidebar */}
              <div className="col-lg-3">
                <Sidebar></Sidebar>
              </div>

              {/* Main Content */}
              <div className="col-lg-9">
                {/* <DashboardHeader></DashboardHeader> */}

                <div className="card mt-30">
                  <div className="card-header bg-white">
                    <h5 className="card-title">Notification List</h5>
                  </div>

                  <div className="card-body">
                    {/* Sample Notification - you can map over real data here */}
                    {notificationList?.length !== 0 ?
                      <div>
                        {notificationList?.map((item, index) => (
                          <div className="notification-wraper" key={index}>
                            <div className="notification-containt">
                              <h5>{item.title}</h5>
                              <div className="notification-date">
                              {item?.created_at &&
                              new Date(item.created_at).toLocaleDateString('en-GB').replace(/\//g, '-')
                            }
                              </div>
                            </div>
                            <div className="notification-description">
                              {item.message}
                            </div>
                          </div>
                        ))}
                      </div>
                      :
                      <div className="col-12 text-center my-5">
                        <img
                          src="/images/nodatafoundimg.png"
                          alt="No addresses found"
                          className="img-fluid mb-3"
                          style={{ maxWidth: "200px" }}
                        />
                        <p>No notification found.</p>
                      </div>
                    }
                  </div>
                </div>
              </div>
              {/* End Main Content */}
            </div>
          </div>
        </section>
        {/* About-us End */}
      </div>
      {/* Page Content End */}
    </>
  );
};

export default Notifications;
